export const marketLang = {
    title: {
        'en': 'PURCHASE $ARTY COINS',
        'fr': 'ACHETER DES JETONS $ARTY',
        'de': '$ARTY-COINS KAUFEN',
        'ko': '$ARTY 코인 구매',
        'ch': '购买 $ARTY 代币',
        'ru': 'Купленные монеты $ARTY',
        'it': 'ACQUISTA MONETE $ARTY',
        'jap': '$ARTYコインを購入',
        'port': 'COMPRAR MOEDAS $ARTY ',
        'turk': '$ARTY COIN AL',
        'viet': 'MUA COIN ARTY$',
        'spa': 'COMPRA DE MONEDAS $ARTY',
        'arab': 'شراء عملات $ARTY'
    },
    support: {
        'en': 'After your transfer confirmed, your will see your $ARTY tokens on your balance in Launchpad account. For any questions please contact our',
        'fr': 'Une fois la transaction confirmée, vos jetons $ARTY seront crédités sur le solde de votre compte. Pour toute question, veuillez contacter notre service',
        'de': 'Nach der Bestätigung der Transaktion werden Ihre $ARTY Ihrem Kontostand gutgeschrieben. Bei Fragen wenden Sie sich bitte an unseren',
        'ko': '트랜잭션이 확인 된 후,당신의$예술적인 토큰은 계정 잔액에 적립됩니다. 질문이 있으시면 지원 팀에',
        'ch': '交易确认后，您的$ARTY代币将记入您的帐户余额。 如有任何问题，',
        'ru': 'После подтверждения транзакции ваши $ARTY зачислятся на баланс вашего аккаунта. По любым вопросам пожалуйста обращайтесь в нашу',
        'it': 'Una volta confermato il pagamento, vedrai i tuoi token $ARTY nel saldo del tuo account. Per qualsiasi domanda contatta il nostro',
        'jap': '決済が確認されると、口座残高に$ARTYトークンが表示されます。ご不明な点がありましたらサポートまでお問い合わせく',
        'port': 'Assim que seu pagamento for confirmado, você verá seus tokens $ARTY em saldo em sua conta. Qualquer dúvida entre em contato com nosso',
        'turk': 'Ödemeniz onaylandıktan sonra, $ARTY tokenleriniz hesabınızdaki bakiyenizde görünecektir. Tüm sorularınız için lütfen destek birimimize',
        'viet': 'Sau khi thanh toán của bạn được xác nhận, bạn sẽ thấy các token ARTY$ của mình trên số dư tài khoản. Nếu có bất cứ câu hoi nào, vui lòng liên hệ với đội ngũ hỗ trợ',
        'spa': 'Cuando hayamos confirmado tu pago, tus tokens $ARTY aparecerán en el saldo de tu cuenta. Si tienes alguna pregunta, contacta con nuestro servicio',
        'arab': 'أسئلة يرجى الاتصال بدعمنا. بمجرد تأكيد الدفع الخاص بك، سترى عملة ARTY$ ا ستكون قادرًا على سح'
    },
    support2: {
        'en': 'support',
        'fr': 'dassistance',
        'de': 'Support',
        'ko': '문의하십시오',
        'ch': '请联系我们的支持。',
        'ru': 'поддержку',
        'it': 'supporto',
        'jap': 'ださい。',
        'port': 'suporte',
        'turk': 'ulaşın',
        'viet': 'của chúng tôi',
        'spa': 'de soporte',
        'arab': 'لأية'
    },
    accept: {
        'en': 'We Accept:',
        'fr': 'Nous acceptons:',
        'de': 'Wir akzeptieren:',
        'ko': '허용:',
        'ch': '我们接受：',
        'ru': 'Мы принимаем:',
        'it': 'Accettiamo:',
        'jap': '対応',
        'port': 'Nós aceitamos:',
        'turk': 'Kabul Edilir:',
        'viet': 'Chúng tôi chấp nhận:',
        'spa': 'Aceptamos:',
        'arab': 'نحن نقبل:'
    },
    amount: {
        'en': 'Amount $',
        'fr': 'Montant en $',
        'de': 'Betrag $',
        'ko': '금액 $',
        'ch': '金额 ($)',
        'ru': 'Количество $',
        'it': 'Quantità di $',
        'jap': '金額 $',
        'port': 'Valor $',
        'turk': 'Tutar $',
        'viet': 'Lượng $',
        'spa': 'Importe en $',
        'arab': 'المبلغ $'
    },
    amount_coin: {
        'en': 'Amount Coin',
        'fr': 'Montant en cryptomonnaie',
        'de': 'Anzahl Coin',
        'ko': '코인 수량',
        'ch': '币数',
        'ru': 'Количество Монет',
        'it': 'Quantità di Moneta',
        'jap': 'コインの金額',
        'port': 'Quantidade de moedas',
        'turk': 'Coin Miktarı',
        'viet': 'Số coin',
        'spa': 'Número de monedas',
        'arab': 'المبلغ بالعملة'
    },
    package: {
        'en': 'Package',
        'fr': 'Forfait',
        'de': 'Paket',
        'ko': '패키지',
        'ch': '套餐',
        'ru': 'Пакет',
        'it': 'Pacchetto',
        'jap': 'パッケージ',
        'port': 'Pacote',
        'turk': 'Paket',
        'viet': 'Gói',
        'spa': 'Paquete',
        'arab': 'الحزمة '
    },
    status: {
        'en': 'Status',
        'fr': 'Statut',
        'de': 'Status',
        'ko': '상태',
        'ch': '状态',
        'ru': 'Статус',
        'it': 'Stato',
        'jap': 'ステータス',
        'port': 'Status',
        'turk': 'Durum',
        'viet': 'Trạng thái',
        'spa': 'Estado',
        'arab': 'حالة'
    },
    time: {
        'en': 'Time',
        'fr': 'Durée',
        'de': 'Zeit',
        'ko': '시간',
        'ch': '时间',
        'ru': 'Время',
        'it': 'Tempo',
        'jap': '時間',
        'port': 'Tempo',
        'turk': 'Zaman',
        'viet': 'Thời gian',
        'spa': 'Tiempo',
        'arab': 'الوقت'
    },
    detailed: {
        'en': 'Detailed info',
        'fr': 'Informations détaillées',
        'de': 'Detaillierte Informationen',
        'ko': '자세한 정보',
        'ch': '详细信息',
        'ru': 'Подробная информация',
        'it': 'Informazioni dettagliate',
        'jap': '詳細情報',
        'port': 'Informações detalhadas',
        'turk': 'Detaylı bilgi',
        'viet': 'Thông tin chi tiết',
        'spa': 'Info. detallada',
        'arab': 'معلومات مفصلة'
    },
    actions: {
        'en': 'Actions',
        'fr': 'Actions',
        'de': 'Aktionen',
        'ko': '작업',
        'ch': '行动',
        'ru': 'Действия',
        'it': 'Azioni',
        'jap': 'アクション',
        'port': 'Ações',
        'turk': 'Eylemler',
        'viet': 'Hoạt động',
        'spa': 'Acciones',
        'arab': 'أجراءات'
    },
}